
import Rater from 'vux/src/components/rater/index.vue'


export default {
components: {
Rater
},
data() {
return {
raterModel: 3
}
},
}



// WEBPACK FOOTER //
// ./src/components/design/components/control/sy-rater.vue